import DeviceScreen from 'lib/DeviceScreen';

const criteoAccountId = '11923';

function criteo() {
  const client = window.criteo_q || (window.criteo_q = []);
  return client;
}

function baseEvents() {
  const events = [{ event: 'setAccount', account: criteoAccountId }];

  // TODO: ported from legacy app, enable once users are supported
  // only push the customer id if we have it
  // if (_.isPresent(this.customerId())) {
  //   events.push({ event: "setCustomerId", id: this.customerId()});
  // }

  let siteType = 'd'; // desktop
  if (DeviceScreen.isPhone()) {
    siteType = 'm'; // mobile
  }
  events.push({ event: 'setSiteType', type: siteType });

  return events;
}

function trackEvent(event) {
  const events = baseEvents();
  events.push(event);
  criteo().push(events);
}

// eslint-disable-next-line import/prefer-default-export
export function trackHomepageView() {
  trackEvent({ event: 'viewHome' });
}

export function trackListingsView(vins, searchString) {
  trackEvent({ event: 'viewList', product: vins, keywords: searchString });
}

export function trackProduct(vin) {
  trackEvent({ event: 'viewItem', product: vin });
}

export function trackLead(vin, price, leadId, isNewCustomer = true) {
  const newCustomer = isNewCustomer ? 1 : 0;
  const event = {
    event: 'trackTransaction',
    id: leadId,
    new_customer: newCustomer,
    product: [{ id: vin, price, quantity: 1 }],
  };
  trackEvent(event);
}

export default {
  trackHomepageView,
  trackProduct,
  trackLead,
  trackListingsView,
};
